// extracted by mini-css-extract-plugin
export default {"wrapper":"Q8-z","message":"R8-z","image":"S8-z"};